import booking from '../../features/booking/router/routes';
import errorPages from '../../features/errors/router/routes';
import cookies from '../../features/cookies/router/routes';
import consent from '../../features/consent/router/routes';

export default [...booking, ...consent, ...errorPages, ...cookies];
